import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Button from '../../../../../../components/global/Button';
import withModal from '../../../../../../components/global/modal/withModal';

const propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func.isRequired,
};

const ContactSpreadsheetImportInstructions = ({ className, onClose }) => {
  const classes = classNames({
    'contact-spreadsheet-import-instructions': true,
    [className]: !!className,
  });

  return (
    <div className={classes}>
      <p>
        Upload a spreadsheet or CSV that contains a list of data (your
        contacts). When importing, make sure that every piece of information has
        its own unique column in that import file. Your Waldo address book
        expects the data to be structured in the following way:
      </p>

      <div className="table-responsive">
        <table className="table table-csv-sample">
          <caption>
            Columns in <span className="text-primary">blue</span> are{' '}
            <em>required</em>.
          </caption>

          <thead className="pb-1">
            <tr>
              <th className="required">First name</th>
              <th className="required">Last name</th>
              <th className="required">Address line 1</th>
              <th className="required">City</th>
              <th className="required">State</th>
              <th className="required">Zip code</th>
              <th>Mobile phone</th>
              <th>Birth date</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>Jane</td>
              <td>Doe</td>
              <td>4237 Garrett Street</td>
              <td>New York</td>
              <td>NY</td>
              <td>49093</td>
              <td>12695357269</td>
              <td>1984-12-24</td>
            </tr>

            <tr>
              <td>Brad</td>
              <td>Peters</td>
              <td>1415 Juniper Dr.</td>
              <td>Saginaw</td>
              <td>MI</td>
              <td>49093</td>
              <td>19897990743</td>
              <td />
            </tr>

            <tr className="pt-1">
              <td colSpan="9">etc&hellip;</td>
            </tr>
          </tbody>
        </table>
      </div>

      <p className="text-extra-bold mb-1 text-sm">
        Accepted files &amp; sample spreadsheet:
      </p>
      <p className="text-sm">
        Accepted file formats are <code>.xls</code>, <code>.xlsx</code>, and{' '}
        <code>.csv</code>. Download a{' '}
        <a
          href="https://d1ldwnjkukjs70.cloudfront.net/waldo-contacts-template.xlsx"
          download
        >
          sample spreadsheet template here
        </a>
        .
      </p>

      <div className="row">
        <div className="col-6">
          <p className="text-extra-bold mb-1 text-sm">Required fields:</p>
          <p className="text-sm">
            First name, Last name, and all Address fields are required data
            fields for every contact. All fields will be editable after the
            import.
          </p>
        </div>
        <div className="col-6">
          <p className="text-extra-bold mb-1 text-sm">Optional fields:</p>
          <p className="text-sm">
            You can skip optional data by leaving their values empty in your
            spreadsheet.
          </p>
        </div>
        <div className="col-6">
          <p className="text-extra-bold mb-1 text-sm">Mobile phone numbers:</p>
          <p className="text-sm">
            All mobile phone numbers (if provided) should have the country
            suffix prepended (1 for the USA), i.e. formatted according to the{' '}
            <a
              href="https://en.wikipedia.org/wiki/E.164"
              target="_blank"
              rel="noopener noreferrer"
            >
              E.164 standard format
            </a>
            .
          </p>
        </div>
        <div className="col-6">
          <p className="text-extra-bold mb-1 text-sm">Birth date:</p>
          <p className="text-sm">
            The birth date (if provided) should be in the following format:{' '}
            <code>YYYY-MM-DD</code>, where <code>&rdquo;Y&ldquo;</code> stands
            for Year,
            <code>&rdquo;M&ldquo;</code> for Month, and{' '}
            <code>&rdquo;D&ldquo;</code> for Day. If you import a spreadsheet
            usually this is already taken care of automatically by the file
            itself.
          </p>
        </div>
      </div>

      <div className="text-center">
        <Button onClick={onClose} btnStyle="link" className="mt-3">
          Dismiss
        </Button>
      </div>
    </div>
  );
};

ContactSpreadsheetImportInstructions.propTypes = propTypes;

export default withModal(ContactSpreadsheetImportInstructions, {
  contentLabel: 'Importing Instructions',
  type: 'full',
  size: 'md',
  overlayClassName: 'z-modal-max',
});
